import axiosInstance from 'api/axiosInstance'
import {
    type PaymentPlan,
    type PromoCampaign,
    type SubscriptionPlan
} from 'types/api/subscription'

export const createSubscriptionPlan = async (newPlan: SubscriptionPlan) => {
    try {
        const { data } = await axiosInstance({
            method: 'POST',
            url: 'api/subscription/create/plan',
            data: {
                price: newPlan.price,
                name: newPlan.name,
                month_count: newPlan.length,
                discount: newPlan.discount,
                active: 1
            }
        })
        return data?.data
    } catch (error) {
        console.error('Error:', error)
    }
}

export const getSubscriptionPlans = async (id: string) => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: `/api/subscription/prices/${id}`
        })
        return data?.data
    } catch (error) {
        console.error('Error:', error)
    }
}

export const updateSubscriptionPlans = async (newPlan: PaymentPlan) => {
    try {
        const { data } = await axiosInstance({
            method: 'PUT',
            url: `/api/subscription/plan/${newPlan.id}`,
            data: newPlan
        })

        return data.data
    } catch (error) {
        console.error('Error:', error)
    }
}

export const deleteSubscriptionPlan = async (planId: number) => {
    try {
        const { data } = await axiosInstance({
            method: 'DELETE',
            url: `/api/subscription/plan/${planId}`
        })
        return data?.data
    } catch (error) {
        console.error('Error:', error)
    }
}

export const getPromoCampaigns = async (type?: string) => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: '/api/subscription/campaigns'
        })

        if (type) {
            return data.data.filter((item: any) => item.type === type)
        }
        return data?.data
    } catch (error) {
        console.error('Error:', error)
    }
}
export const getFreeTrialLinks = async () => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: '/api/subscription/free-trial-links'
        })

        return data?.data
    } catch (error) {
        console.error('Error:', error)
    }
}

export const createPromoCampaign = async (camapaignData: PromoCampaign) => {
    try {
        const { data } = await axiosInstance({
            method: 'POST',
            url: '/api/subscription/create/campaign',
            data: camapaignData
        })
        return data
    } catch (error: any) {
        console.error('Error:', error)
        throw error.response?.data || error;
    }
}

export const updatePromoCampaign = async (
    id: number,
    campaignData: PromoCampaign
) => {
    try {
        const { data } = await axiosInstance({
            method: 'PUT',
            url: `/api/subscription/campaign/${id}`,
            data: campaignData
        })

        return data
    } catch (error: any) {
        console.error('Error:', error)
        throw error.response?.data || error;
    }
}

export const deletePromoCampaign = async (id: number) => {
    try {
        const { data } = await axiosInstance({
            method: 'DELETE',
            url: `/api/subscription/campaign/${id}`
        })
        return data
    } catch (error) {
        console.error('Error:', error)
    }
}

export const getFreeTrialLink = async (id: number) => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: `/api/subscription/campaign/trial-link?campaign_id=${id}`
        })

        return data.data
    } catch (error) {
        console.error('Error:', error)
    }
}

export const resolveTrialLink = async (code: string, answer?: boolean) => {
    try {
        const { data } = await axiosInstance({
            method: 'POST',
            url: '/api/subscription/trial-link',
            data: {
                trial_code: code,
                answer
            }
        })
        return data.data
    } catch (error) {
        console.error('Error:', error)
    }
}
export const acceptTrialLink = async (code: string) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/subscription/trial-link/accept',
        data: {
            trial_code: code
        }
    })

    return data.data
}
export const setSubscriptionRenewal = async (
    id: string,
    enableRenewal: boolean = true
) => {
    try {
        const { data } = await axiosInstance({
            method: 'PUT',
            url: `/api/subscription/renewal/${id}`,
            data: { renewal: enableRenewal }
        })
        return data
    } catch (error) {
        console.error('Error:', error)
    }
}
export const updateSubscriptionPrice = async (price: number) => {
    try {
        const { data } = await axiosInstance({
            method: 'PUT',
            url: '/api/subscription-price',
            data: {
                price
            }
        })

        return data?.data
    } catch (error) {
        console.error('Error:', error)
        throw error
    }
}